export const ReportingEndpoints = {
  GetActivities: 'Activity/GetActivitys',
  GetActivitiesV2: 'Activity/GetActivities',
  GetActivitiesFilter: 'Activity/GetActivitiesFilter',
  GetPrintDetails: 'Activity/GetPrintDetailLink',
  ContactInvestor: 'Activity/ContactInvestor',
  GetActivityCounts: 'Activity/GetActivityCounts',
  GetActivitiesCounts: 'Activity/GetActivitiesCounts',
  GetInvestmentHistory: 'Investors/GetInvestmentHistory',
  GetSummary: 'Activity/GetSummary',
  GetLast24Months: 'Reports/GetLast24MonthsTransactionDetails',
  GetAccountStatements: 'Reports/AccountStatements',
  GetOutstandingInvoices: 'Reports/OustandingInvoices',
  GetActivityExport: 'Reports/ActivityExcelExportV2',
  GetProgramReport: 'Reports/ProgramPeriodReportExport',
  GetInvestmentProgramReport: 'Reports/InvestmentProgramReportExport',
  GetInvestmentActivityByCalendarYearExport:
    'Reports/InvestmentActivityExcelExport',
  GetSiteProjection: 'Projection/GetSiteProjection',
  GetSiteProjectionMeta: 'Projection/GetSiteProjectionMeta',
  GetSiteProjectionBilling: 'Projection/GetSiteProjectionBilling',
  UpdateSiteForecast: 'Projection/UpdateSiteForecast',
} as const;
